import { render } from "./Website_Security.vue?vue&type=template&id=1e5758d7&scoped=true"
import script from "./Website_Security.vue?vue&type=script&lang=js"
export * from "./Website_Security.vue?vue&type=script&lang=js"

import "./Website_Security.vue?vue&type=style&index=0&id=1e5758d7&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5758d7"]])

export default __exports__